import { render } from "./MemberCard.vue?vue&type=template&id=3f12d7b8&scoped=true&ts=true&lang=pug"
import script from "./MemberCard.vue?vue&type=script&lang=ts"
export * from "./MemberCard.vue?vue&type=script&lang=ts"

import "./MemberCard.vue?vue&type=style&index=0&id=3f12d7b8&scoped=true&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f12d7b8"]])

export default __exports__